<!-- eslint-disable vue/valid-v-slot -->
<template>
  <div class="pointsdrivers-page">
    <div class="page-header">
      <div class="page-header-text">
        <h1 class="page-title">Punkty kierowców</h1>
      </div>
    </div>
    <v-data-table
      :headers="headers"
      :items="drivers"
      class="elevation-1"
      :loading="loading"
      :options.sync="options"
      :server-items-length="totalItems"
    >
      <template v-slot:top>
        <div class="table-section-title">
          <div class="filter-icon"><v-icon size="18" color="#5478FF">mdi-star</v-icon></div>
          <div class="filter-title">{{ $t('pointsDrivers.title') }}</div>
        </div>
            <div>
              <v-row class="mx-2">
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="search"
                    :label="$t('pointsDrivers.searchDriver')"
                    clearable
                    @click:clear="search = ''"
                  ></v-text-field>
                </v-col>
              </v-row>
            </div>
          </template>
          <template v-slot:item.driverName="{ item }">
            <a
              href="#"
              @click.prevent="goToDriver(item.driverId)"
              style="text-decoration: underline; cursor: pointer; color: #1976d2;"
            >
              {{ item.driverName }}
            </a>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-btn small color="info" class="mr-2" @click="openHistory(item)">
              <v-icon small>mdi-history</v-icon>
            </v-btn>
            <v-btn small color="warning" @click="openCorrectionDialog(item)">
              <v-icon small>mdi-pencil</v-icon>
            </v-btn>
          </template>
    </v-data-table>

    <!-- Correction Dialog -->
    <v-dialog content-class="dark-form-dialog" v-model="correctionDialog" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="text-h6">{{ $t('pointsDrivers.pointsCorrection') }} - {{ correctionDriverName }}</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="correctionForm" v-model="correctionFormValid">
            <v-text-field
              v-model.number="correctionPoints"
              label="Punkty (ujemne = odjecie)"
              type="number"
              outlined
              :rules="[rules.required, rules.notZero]"
            />
            <v-textarea
              v-model="correctionDescription"
              label="Opis korekty"
              outlined
              :rules="[rules.required]"
              rows="3"
            />
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="secondary" @click="correctionDialog = false">{{ $t('common.cancel') }}</v-btn>
          <v-btn color="primary" :disabled="!correctionFormValid" @click="submitCorrection">
            {{ $t('pointsDrivers.saveCorrection') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- History Dialog -->
    <v-dialog content-class="dark-form-dialog" v-model="historyDialog" max-width="800px">
      <v-card>
        <v-card-title>
          <span class="text-h6">{{ $t('pointsDrivers.pointsHistory') }} - {{ historyDriverName }}</span>
        </v-card-title>
        <v-card-text>
          <v-data-table
            :headers="historyHeaders"
            :items="historyItems"
            :loading="historyLoading"
            dense
          >
            <template v-slot:item.points="{ item }">
              <span :class="item.points > 0 ? 'green--text' : 'red--text'">
                {{ item.points > 0 ? '+' : '' }}{{ item.points }}
              </span>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="secondary" @click="historyDialog = false">{{ $t('common.close') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Swal from "sweetalert2";
const axios = require("axios");
import * as dayjs from "dayjs";
export default {
  data() {
    return {
      loading: false,
      drivers: [],
      totalItems: 0,
      search: "",
      options: {
        page: 1,
        itemsPerPage: 20,
      },
      headers: [
        { text: "Kierowca", value: "driverName", sortable: false },
        { text: "Saldo", value: "balance", sortable: false },
        { text: "Ten miesiac", value: "thisMonth", sortable: false },
        { text: "Akcje", value: "actions", sortable: false },
      ],
      // Correction
      correctionDialog: false,
      correctionFormValid: false,
      correctionDriverId: null,
      correctionDriverName: "",
      correctionPoints: null,
      correctionDescription: "",
      // History
      historyDialog: false,
      historyLoading: false,
      historyDriverName: "",
      historyItems: [],
      historyHeaders: [
        { text: "Data", value: "date", sortable: false },
        { text: "Punkty", value: "points", sortable: false },
        { text: "Typ", value: "type", sortable: false },
        { text: "Opis", value: "description", sortable: false },
      ],
      rules: {
        required: (v) => !!v || v === 0 || "Wymagane",
        notZero: (v) => v !== 0 || "Wartosc nie moze byc zerowa",
      },
    };
  },
  async created() {
    await this.initialize();
  },
  watch: {
    options: {
      handler() {
        this.initialize();
      },
      deep: true,
    },
    search: {
      handler() {
        this.options.page = 1;
        this.initialize();
      },
    },
  },
  methods: {
    getAuthHeaders() {
      return {
        Authorization: "Bearer " + localStorage.getItem("token"),
      };
    },
    async toggleLoading(type) {
      localStorage.setItem("loading", type);
      window.dispatchEvent(
        new CustomEvent("toggleLoading", {
          detail: {
            loading: localStorage.getItem("loading"),
            overlay: localStorage.getItem("loading"),
          },
        })
      );
    },
    goToDriver(id) {
      if (id) location.href = "/driver-details?id=" + id;
    },
    async initialize() {
      this.loading = true;
      try {
        const take = this.options.itemsPerPage;
        const skip = (this.options.page - 1) * take;
        const searchParam = this.search ? this.search.trim() : "";
        const res = await axios({
          method: "get",
          url:
            process.env.VUE_APP_ROOT_API +
            `points/admin/drivers/points?take=${take}&skip=${skip}&search=${searchParam}`,
          headers: this.getAuthHeaders(),
        });
        const data = res.data.data || res.data;
        const result = data.result || data.items || data;
        this.totalItems = data.count || data.total || result.length;
        this.drivers = (Array.isArray(result) ? result : []).map((item) => {
          return {
            driverId: item.driverId || item.id,
            driverName:
              item.driverName ||
              (item.driver
                ? item.driver.firstName + " " + item.driver.lastName
                : "-"),
            balance: item.balance != null ? item.balance : 0,
            thisMonth: item.thisMonth != null ? item.thisMonth : 0,
          };
        });
      } catch (e) {
        console.log(e);
        Swal.fire(
          "Blad",
          e.response?.data?.message?.toString() || "Wystapil blad",
          "error"
        );
      }
      this.loading = false;
    },
    openCorrectionDialog(item) {
      this.correctionDriverId = item.driverId;
      this.correctionDriverName = item.driverName;
      this.correctionPoints = null;
      this.correctionDescription = "";
      this.correctionDialog = true;
      this.$nextTick(() => {
        if (this.$refs.correctionForm) this.$refs.correctionForm.resetValidation();
      });
    },
    async submitCorrection() {
      if (!this.$refs.correctionForm.validate()) return;
      this.correctionDialog = false;
      await this.toggleLoading(true);
      try {
        await axios({
          method: "post",
          url: process.env.VUE_APP_ROOT_API + "points/admin/points/correction",
          headers: this.getAuthHeaders(),
          data: {
            driverId: this.correctionDriverId,
            points: this.correctionPoints,
            description: this.correctionDescription,
          },
        });
        Swal.fire("Zapisano", "Korekta punktow zostala zapisana", "success");
        await this.initialize();
      } catch (e) {
        console.log(e);
        Swal.fire(
          "Blad",
          e.response?.data?.message?.toString() || "Wystapil blad",
          "error"
        );
      }
      await this.toggleLoading(false);
    },
    translateSource(source) {
      const map = {
        EARNINGS: "Zarobki",
        REFERRAL: "Polecenie",
        REVIEW: "Opinia",
        CORRECTION: "Korekta",
        REWARD: "Nagroda",
        BONUS: "Bonus",
        RANKING: "Ranking",
      };
      return map[source] || source;
    },
    async openHistory(item) {
      this.historyDriverName = item.driverName;
      this.historyItems = [];
      this.historyDialog = true;
      this.historyLoading = true;
      try {
        const res = await axios({
          method: "get",
          url:
            process.env.VUE_APP_ROOT_API +
            "points/admin/drivers/" +
            item.driverId +
            "/history",
          headers: this.getAuthHeaders(),
        });
        const data = res.data.data || res.data;
        const result = Array.isArray(data) ? data : data.result || data.items || [];
        this.historyItems = result.map((h) => {
          const source = h.source || h.type || "-";
          return {
            date: h.createdAt
              ? dayjs(h.createdAt).format("DD-MM-YYYY HH:mm")
              : h.date
              ? dayjs(h.date).format("DD-MM-YYYY HH:mm")
              : "-",
            points: h.points || 0,
            type: this.translateSource(source),
            description: h.description || "-",
          };
        });
      } catch (e) {
        console.log(e);
        Swal.fire(
          "Blad",
          e.response?.data?.message?.toString() || "Wystapil blad",
          "error"
        );
      }
      this.historyLoading = false;
    },
  },
};
</script>

<style scoped>
.pointsdrivers-page { background: #181C28; min-height: calc(100vh - 56px); padding: 16px 16px 40px; margin: -24px; color: #fff; }
.page-header { padding: 4px 4px 18px; }
.page-eyebrow { font-size: 12px; color: #6E7691; font-weight: 500; text-transform: capitalize; }
.page-title { font-size: 22px; font-weight: 800; color: #fff; margin: 2px 0 0; letter-spacing: -0.02em; }
.table-section-title { display: flex; align-items: center; gap: 10px; padding: 14px 16px 12px; border-bottom: 1px solid rgba(255,255,255,0.06); }
.filter-icon { width: 32px; height: 32px; border-radius: 10px; background: rgba(41,98,255,0.18); display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
.filter-title { font-size: 15px; font-weight: 700; color: #fff; flex-grow: 1; }

.pointsdrivers-page >>> .v-card { background: #232838 !important; border: 1px solid rgba(255,255,255,0.06) !important; border-radius: 18px !important; box-shadow: none !important; color: #fff !important; }
.pointsdrivers-page >>> .v-card .v-card__title { color: #fff !important; padding: 16px 20px 8px !important; font-weight: 700 !important; font-size: 15px !important; }
.pointsdrivers-page >>> .v-text-field--outlined fieldset, .pointsdrivers-page >>> .v-select--outlined fieldset { border-color: rgba(255,255,255,0.1) !important; }
.pointsdrivers-page >>> .v-text-field--outlined .v-input__slot, .pointsdrivers-page >>> .v-select--outlined .v-input__slot { background: #181C28 !important; border-radius: 12px !important; }
.pointsdrivers-page >>> .v-label { color: #6E7691 !important; }
.pointsdrivers-page >>> .v-text-field input, .pointsdrivers-page >>> .v-select__selection { color: #fff !important; }
.pointsdrivers-page >>> .v-data-table { background: #232838 !important; border: 1px solid rgba(255,255,255,0.06) !important; border-radius: 18px !important; color: #fff !important; box-shadow: none !important; }
.pointsdrivers-page >>> .v-data-table thead tr th { background: #1F2434 !important; color: #6E7691 !important; font-size: 11px !important; font-weight: 700 !important; text-transform: uppercase; letter-spacing: 0.04em; border-bottom: 1px solid rgba(255,255,255,0.06) !important; }
.pointsdrivers-page >>> .v-data-table tbody tr { background: #232838 !important; }
.pointsdrivers-page >>> .v-data-table tbody tr:hover { background: #2A3042 !important; }
.pointsdrivers-page >>> .v-data-table tbody tr td { color: #fff !important; border-bottom: 1px solid rgba(255,255,255,0.04) !important; }
.pointsdrivers-page >>> .v-data-table a { color: #5478FF !important; }
.pointsdrivers-page >>> .v-data-footer { background: #1F2434 !important; color: #B0BEC5 !important; border-top: 1px solid rgba(255,255,255,0.06) !important; }
.pointsdrivers-page >>> .v-toolbar { background: transparent !important; color: #fff !important; }
.pointsdrivers-page >>> .v-btn:not(.v-btn--icon) { border-radius: 10px !important; text-transform: none !important; font-weight: 600 !important; }
.pointsdrivers-page >>> .v-data-table tbody td .v-btn.warning { background: rgba(255,152,0,0.18) !important; color: #FFB74D !important; box-shadow: none !important; }
.pointsdrivers-page >>> .v-data-table tbody td .v-btn.info { background: rgba(66,165,245,0.18) !important; color: #64B5F6 !important; box-shadow: none !important; }
.pointsdrivers-page >>> .v-data-table tbody td .v-btn .v-icon { color: inherit !important; }
.pointsdrivers-page >>> .v-chip { border-radius: 999px !important; font-weight: 700 !important; }
.pointsdrivers-page >>> .v-divider { border-color: rgba(255,255,255,0.06) !important; }
.pointsdrivers-page >>> .v-progress-linear { background: rgba(255,255,255,0.06) !important; }
.pointsdrivers-page >>> .v-dialog .v-card { background: #232838 !important; }
</style>
